"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneFromTemplateArtifact = void 0;
const uuid_1 = require("uuid");
const cloneUtils_1 = require("../cloneUtils");
const node_1 = require("./node");
const cloneConfig = ({ config, cloneMap, }) => {
    const { tapeDescription, lenderVerificationConfig, fundingSubmissionComponentsArtifactSlug, } = config;
    const clonedLenderVerificationConfig = lenderVerificationConfig
        ? {
            ...lenderVerificationConfig,
            receivableResponseTapeArtifactSlug: (0, cloneUtils_1.getClonedArtifactSlug)(lenderVerificationConfig.receivableResponseTapeArtifactSlug, cloneMap),
            borrowingBaseReportArtifactSlug: (0, cloneUtils_1.getClonedArtifactSlug)(lenderVerificationConfig.borrowingBaseReportArtifactSlug, cloneMap),
            borrowerNumbersArtifactSlug: (0, cloneUtils_1.getClonedArtifactSlug)(lenderVerificationConfig.borrowerNumbersArtifactSlug, cloneMap),
            borrowerEligibilityResultsArtifactSlugs: Object.fromEntries(Object.entries(lenderVerificationConfig.borrowerEligibilityResultsArtifactSlugs).map(([key, value]) => [
                (0, cloneUtils_1.getClonedArtifactSlug)(key, cloneMap),
                (0, cloneUtils_1.getClonedArtifactSlug)(value, cloneMap),
            ])),
        }
        : undefined;
    return {
        tapeDescription,
        lenderVerificationConfig: clonedLenderVerificationConfig,
        fundingSubmissionComponentsArtifactSlug: (0, cloneUtils_1.getClonedArtifactSlug)(fundingSubmissionComponentsArtifactSlug, cloneMap),
    };
};
const cloneFromTemplateArtifact = ({ artifactToClone, newArtifactDocumentId, cloneMap, }) => {
    const configuration = cloneConfig({
        config: artifactToClone.configuration,
        cloneMap,
    });
    return {
        artifactSlug: (0, cloneUtils_1.getClonedArtifactSlug)(artifactToClone.artifactSlug, cloneMap),
        artifactDocumentId: newArtifactDocumentId,
        creditFacilitySlug: (0, cloneUtils_1.getClonedSlug)(artifactToClone.creditFacilitySlug, cloneMap),
        loanProductSlug: (0, cloneUtils_1.getClonedSlug)(artifactToClone.loanProductSlug, cloneMap),
        externalFilename: null,
        id: (0, uuid_1.v4)(),
        type: node_1.artifactType,
        configuration,
    };
};
exports.cloneFromTemplateArtifact = cloneFromTemplateArtifact;
//# sourceMappingURL=clone.js.map